import React, { useState, useEffect } from 'react';
import { object, func, bool, string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { ALERT_TYPE, ShowToastMessage, sequenceActionNext } from '@laramie/ui';
import { TableCustom, MessageModal } from '../../common';
import { CloneObject } from '../../../utils/helpers';
import { getDateToString } from '../../../utils/convert';
import { useEntidad, useLista } from '../../hooks';
import DomicilioComercioModal from '../DomicilioComercioModal';

const DomiciliosComercioGrid = (props) => {

    //hooks
    const [state, setState] = useState({
        idComercio: 0,
        domicilioComercio: null,
        showMessage: false,
        showForm: false,
        modeFormEdit: false,
        rowForm: null,
        list: []
    });

    const dispatch = useDispatch();
    const sequenceValue = useSelector( (state) => state.sequence.value );

    const mount = () => {
        const domicilioComercio = props.data.domicilioComercio;
        const list = (domicilioComercio && domicilioComercio.state !== 'r') ? [domicilioComercio] : [];
        setState(prevState => {
            return {...prevState,
                idComercio: props.data.idComercio,
                domicilioComercio: domicilioComercio,
                list: list };
        });
    }
    useEffect(mount, [props.data]);

    const [getListLista, ] = useLista({
        listas: ['TipoGeoreferencia'],
        onLoaded: (listas, isSuccess, error) => {
            if (!isSuccess) {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        },
        memo: {
            key: 'TipoGeoreferencia',
            timeout: 0
        }
    });

    const [, getRowEntidad] = useEntidad({
        entidades: ['Provincia', 'Localidad'],
        onLoaded: (entidades, isSuccess, error) => {
            if (isSuccess) {
                setState(prevState => ({...prevState}));
            }
            else {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        },
        memo: {
            key: 'Provincia_Localidad',
            timeout: 0
        }
    });

    const getDescEntidad = (entidad, id) => {
        const row = getRowEntidad(entidad, id);
        return (row) ? row.nombre : '';
    }

    const getDomicilio = (direccion) => {
        if (!direccion) return '';
        const calle = [direccion.calle, direccion.altura, direccion.piso, direccion.dpto].filter(x => x).join(' ') || direccion.referencia;
        const codigoPostal = (direccion.codigoPostal) ? ` (CP ${direccion.codigoPostal})` : '';
        return [getDescEntidad('Provincia', direccion.idProvincia), getDescEntidad('Localidad', direccion.idLocalidad), calle]
            .filter(x => x)
            .join(', ') + codigoPostal;
    }

    const cellA = (data) =>    <div className='action'>
                                {!props.disabled && state.list.length === 0 && (
                                    <div onClick={ (event) => handleClickDomicilioComercioAdd() } className="link">
                                        <span className="material-symbols-outlined" title="Nuevo">add</span>
                                    </div>
                                )}
                              </div>
    const cellVMR = (data) =>  <div className='action'>
                                  <div onClick={ (event) => handleClickDomicilioComercioView(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Ver">search</span>
                                  </div>
                                  {!props.disabled && (
                                  <div onClick={ (event) => handleClickDomicilioComercioModify(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Modificar">stylus</span>
                                  </div>
                                  )}
                                  {!props.disabled && (
                                  <div onClick={ (event) => handleClickDomicilioComercioRemove(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Eliminar">delete</span>
                                  </div>
                                  )}
                              </div>

    const tableColumns = [
        { Header: 'Domicilio', Cell: (props) => getDomicilio(props.row.original.direccion), id: 'domicilio', accessor: 'id', width: '60%', disableSortBy: true },
        { Header: 'Inicio', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaInicio', width: '15%' },
        { Header: 'Baja', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaBaja', width: '15%' },
        { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '10%', disableGlobalFilter: true, disableSortBy: true }
    ];

    //handles
    const handleClickDomicilioComercioAdd = () => {
        const listTipoGeoreferencia = getListLista('TipoGeoreferencia');
        const idTipoGeoreferencia = (listTipoGeoreferencia.length > 0) ? listTipoGeoreferencia[0].id : 530;

        const domicilioExistente = (state.domicilioComercio && state.domicilioComercio.id > 0) ? state.domicilioComercio : null;
        const id = (domicilioExistente) ? domicilioExistente.id : (-1)*sequenceValue;

        setState(prevState => {
            const rowForm = {
                id: id,
                idComercio: (domicilioExistente) ? domicilioExistente.idComercio : state.idComercio,
                fechaInicio: null,
                fechaBaja: null,
                state: 'a',
                direccion: {
                    id: (domicilioExistente) ? domicilioExistente.direccion.id : 0,
                    entidad: "DomicilioComercio",
                    idEntidad: id,
                    idTipoGeoreferencia: idTipoGeoreferencia,
                    idPais: 0,
                    idProvincia: 0,
                    idLocalidad: 0,
                    idZonaGeoreferencia: 0,
                    codigoPostal: "",
                    calle: "",
                    entreCalle1: "",
                    entreCalle2: "",
                    altura: "",
                    piso: "",
                    dpto: "",
                    referencia: "",
                    longitud: 0,
                    latitud: 0,
                    origen: ""
                }
            };
            return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
        });
        if (!domicilioExistente) dispatch( sequenceActionNext() );
    }

    const handleClickDomicilioComercioView = (id) => {
        setState(prevState => {
            const rowForm = state.list.find(x => x.id === id);
            return {...prevState, showForm: true, modeFormEdit: false, rowForm: rowForm};
        });
    }

    const handleClickDomicilioComercioModify = (id) => {
        setState(prevState => {
            const rowForm = state.list.find(x => x.id === id);
            return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
        });
    }

    const handleClickDomicilioComercioRemove = (id) => {
        setState(prevState => {
            const rowForm = state.list.find(x => x.id === id);
            return {...prevState, showMessage: true, rowForm: rowForm};
        });
    }

    //funciones
    function RemoveDomicilioComercio(row) {
        row.state = 'r';
        props.onChange('DomicilioComercio', row);
    }

    function UpdateDomicilioComercio(row) {
        row.state = (row.id > 0 || state.list.some(x => x.id === row.id)) ? 'm' : 'a';
        props.onChange('DomicilioComercio', row);
    }

    return (
    <>

        {state.showMessage &&
            <MessageModal
                title={"Confirmación"}
                message={"¿Está seguro de borrar el registro?"}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, showMessage: false, rowForm: null};
                    });
                }}
                onConfirm={() => {
                    const row = CloneObject(state.rowForm);
                    setState(prevState => {
                        return {...prevState, showMessage: false, rowForm: null};
                    });
                    RemoveDomicilioComercio(row);
                }}
            />
        }

        {state.showForm &&
            <DomicilioComercioModal
                processKey={props.processKey}
                disabled={!state.modeFormEdit}
                data={{
                    entity: state.rowForm
                }}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, showForm: false, rowForm: null};
                    });
                }}
                onConfirm={(row) => {
                    setState(prevState => {
                        return {...prevState, showForm: false, rowForm: null};
                    });
                    UpdateDomicilioComercio(row);
                }}
            />
        }

        <TableCustom
            showFilterGlobal={false}
            className={'TableCustomBase'}
            columns={tableColumns}
            data={state.list}
        />

    </>
    );
}

DomiciliosComercioGrid.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onChange: func.isRequired
};

DomiciliosComercioGrid.defaultProps = {
    disabled: false
};

export default DomiciliosComercioGrid;
